/**
 * Created by JIocb on 26.06.2017.
 */
namespace Factive.Core {
    import Signal = Factive.Core.Signal.Signal;

    export class HandlerContainer {
        public handler:Function;
        public context:any;

        constructor(h:Function,ctx:any)
        {
            this.handler = h;
            this.context = ctx;
        }
        public apply(data:any):void
        {
            this.handler.call(this.context,data);
        }
    }
    export class EventBus {

        private _signal:Signal;
        private _handlers:Array<any> = [];

        constructor()
        {
            this._handlers = [];
            this._signal = new Signal();
            this._signal.add(this.handleEvents,this);
        }

        public add(type:string,topic:string,handler,handlerContext):void
        {
            this._handlers = this._handlers || [];
            this._handlers[topic] = this._handlers[topic] || [];
            this._handlers[topic][type] = this._handlers[topic][type] || [];

            var handlers:Array<HandlerContainer> = this._handlers[topic][type];
            var l:number = handlers.length;
            for(var i:number = 0; i<l; i++)
            {
                var container:HandlerContainer = handlers[i];
                if(container.handler == handler && container.context == handlerContext)
                {
                    //console.log("Event Bus :: ",type," already has this handler ",handler,handlerContext);
                    return;
                }
            }

            this._handlers[topic][type][l] = new HandlerContainer(handler,handlerContext);
        };

        public handleEvents(type,topic,data):void
        {

            var types:Array<HandlerContainer> = this._handlers[topic];
            if(types == null || types == undefined) return;

            var handlers:Array<HandlerContainer> = this._handlers[topic][type];
            if(handlers == null || handlers == undefined) return;

            var l:number = handlers.length;
            for(var i:number = 0; i<l; i++) {

                var container: HandlerContainer = handlers[i];
                var obj = {type:type,data:data}
                container.apply(obj);
            }
        };

        public dispatch(type:string,topic:string,data?:any):void
        {
            this._signal.dispatch(type,topic,data);
        };

        public remove(type:string,topic:string,handler,handlerContext):void
        {
            var types:Array<HandlerContainer> = this._handlers[topic];
            if(types == null || types == undefined) return;

            var handlers:Array<HandlerContainer> = this._handlers[topic][type];
            if(handlers == null || handlers == undefined) return;

            var l:number = handlers.length;
            for(var i:number = 0; i<l; i++)
            {
                var container: HandlerContainer = handlers[i];

                if(container.handler == handler && container.context == handlerContext) {

                    handlers.splice(i, 1);
                    return;
                }
            }

        };

        public destroy():void
        {
            this._signal.removeAll();
            this._handlers = null;
        }
    }
}


// WEBPACK FOOTER //
// src/typescript/Core/Event/EventBus.ts